import React, { Component } from "react";
import SelectComponente from "../../../generico/SelectComponente";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import $ from "jquery";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";


export default class AgregarSubsidioPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.getHospitales = this.getHospitales.bind(this);
    this.getMedicos = this.getMedicos.bind(this);
    this.getEnfermedades = this.getEnfermedades.bind(this);
  }

  getInitialState = () => ({
    optionsHospital: [],
    optionsMedico: [],
    optionsEnfermedad: [],
    cantDiasSubsidios: undefined,
    diagnosticoMedico: undefined,
    disableSgte: true,
    nroMaxDiasSubsidio: 0,
    nroMinDiasSubsidio: 0,
    nroHospital: undefined,
    hospitalDescripcion: undefined,
    nroMedico: undefined,
    medicoDescripcion: undefined,
    nroEnfermedad: undefined,
    enfermedadDescripcion: undefined,
    montoARecibir: undefined
  });

  componentDidMount() {
    this.getHospitales();
    this.getMedicos();
    this.getEnfermedades();
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.respuestasData.cantDiasMin !== this.state.nroMinDiasSubsidio ||
      newProps.respuestasData.cantDiasMax !== this.state.nroMaxDiasSubsidio 
    ) {
      this.updateValuesCantDias(newProps.respuestasData.cantDiasMin, newProps.respuestasData.cantDiasMax);
      this.validarNumber(newProps.respuestasData.cantDiasMin, newProps.respuestasData.cantDiasMax);
    }
  }

  updateValuesCantDias(min, max) {
    this.setState({ 
      nroMaxDiasSubsidio: max,
      nroMinDiasSubsidio: min,
    }) 
  }

  handleChangeDias = (e) => {
    this.setState({ cantDiasSubsidios: e.target.value }, () => {
      this.handleValicacion();
    });
  };

  handleChangeDiagnostico = (e) => {
    this.setState({ diagnosticoMedico: e.target.value }, () => {
      this.handleValicacion();
    });
  };

  /*********************
   * HANDLE VALIDACION *
   *********************/

  handleValicacion = () => {
    if (

      (this.state.cantDiasSubsidios >= this.state.nroMinDiasSubsidio && this.state.cantDiasSubsidios <= this.state.nroMaxDiasSubsidio) &&
      this.state.diagnosticoMedico && 
      this.state.nroMedico &&
      this.state.nroHospital &&
      (this.props.respuestasData.claseSubsidio === 210 || this.state.nroEnfermedad)
    )
      this.setState({ disableSgte: false }, () => {}) 
    else {
      this.setState({ disableSgte: true }, () => {})
    }
  };

  validarNumber = (min, max) => {
    $("#idFormReposo").validate({
      onfocusout: function (element) {
        $(element).valid();
      },
      // rules: {
      //   cantidadDias: {
      //     min: min,
      //     max: max,
      //   },
      // },
      messages: {
        cantidadDias: "La cantidad de días no es válida",
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.addClass("is-invalid");
        element.closest(".form-group").append(error);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");

      },
    });
    $("#idFormReposo").rules("add", {
      min: min, 
      max: max,
    })

  };

   /*****************************
   * OBTENER HOSPITALES *
   *****************************/

     getHospitales() {
      let options = [];
      trackPromise(
        SubsidiosService.obtenerHospitales().then((response) => {
          let data = JSON.stringify(response.data);
          //console.log(data)
          let jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (let i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].idHospital,
                label: jsonData.datos[i].nombreHospital,
              });
            }
            this.setState({ optionsHospital: options });
          } else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        })
      );
      return options;
    }
  
    loadHospitales = () => {
      if (this.state.optionsHospital !== undefined) return this.state.optionsHospital;
      else {
        return this.getHospitales();
      }
    };
  
    selectorValues = (dataFromChild, item) => {
      if (dataFromChild === undefined) {
        this.setState({
          nroHospital: undefined,
        });
        return;
      }
  
      this.setState(
        {
          disableSgte: true,
          nroHospital: dataFromChild,
          hospitalDescripcion: item.label
        },
        () => {
          this.handleValicacion();
        }
      );
    };

   /******************
   * OBTENER MEDICOS *
   *******************/

     getMedicos() {
      let options = [];
      trackPromise(
        SubsidiosService.obtenerMedicos().then((response) => {
          let data = JSON.stringify(response.data);
          //console.log(data)
          let jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (let i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].cedula,
                label: jsonData.datos[i].nombreCompleto + " - " +
                "Registro: " +
                formatoSeparadorMilesValue(jsonData.datos[i].registro),
              });
            }
            this.setState({ optionsMedico: options });
          } else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        })
      );
      return options;
    }
  
    loadMedicos = () => {
      if (this.state.optionsMedico !== undefined) return this.state.optionsMedico;
      else {
        return this.getMedicos();
      }
    };
  
    selectorValuesMed = (dataFromChild, item) => {
      if (dataFromChild === undefined) {
        this.setState({
          nroMedico: undefined,
        });
        return;
      }
  
      this.setState(
        {
          disableSgte: true,
          nroMedico: dataFromChild,
          medicoDescripcion: item.label
        },
        () => {
          this.handleValicacion();
        }
      );
    };

  /************************
   * OBTENER ENFERMEDADES *
   ************************/

     getEnfermedades() {
      let options = [];
      trackPromise(
        SubsidiosService.obtenerEnfermedades().then((response) => {
          let data = JSON.stringify(response.data);
          let jsonData = JSON.parse(data);
          console.log(jsonData)
          if (jsonData.codigo === 0) {
            for (let i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].numero,
                label: jsonData.datos[i].descripcion
              });
            }
            this.setState({ optionsEnfermedad: options });
          } else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        })
      );
      return options;
    }
  
    loadEnfermedades = () => {
      if (this.state.optionsEnfermedad !== undefined) return this.state.optionsEnfermedad;
      else {
        return this.getEnfermedades();
      }
    };
  
    selectorValuesEnf = (dataFromChild, item) => {
      if (dataFromChild === undefined) {
        this.setState({
          nroEnfermedad: undefined,
        });
        return;
      }
  
      this.setState(
        {
          disableSgte: true,
          nroEnfermedad: dataFromChild,
          enfermedadDescripcion: item.label
        },
        () => {
          this.handleValicacion();
        }
      );
    };

    getMontoARecibir() {
      trackPromise(
        SubsidiosService.obtenerSubsidioMontoEnfermedad(this.state.nroEnfermedad, this.state.cantDiasSubsidios).then((response) => {
          let data = JSON.stringify(response.data);
          let jsonData = JSON.parse(data);
          console.log(jsonData)
          if (jsonData.codigo === 0) {
          this.setState({ montoARecibir: jsonData.datos },() => {
            this.props.respuestaPaso2(
              this.state.cantDiasSubsidios,
              this.state.diagnosticoMedico,
              this.state.nroHospital,
              this.state.hospitalDescripcion,
              this.state.nroMedico,
              this.state.medicoDescripcion,
              this.state.nroEnfermedad,
              this.state.enfermedadDescripcion,
              this.state.montoARecibir
              )
          }) 
          } else {
            this.setState({ montoARecibir: 0 }) 
            return
          }
        })
      );
    }

  /******************************************
   * CONTINUAR -> CARGA DATOS A SUBSIDIO.JS *
   ******************************************/

  volverSubsidios = () => {
    $("#idFormReposo").rules("remove");
    this.props.previousStep();
  };

  continuar = () => {
  if(this.props.respuestasData.claseSubsidio !== 210) {
    this.getMontoARecibir();
  } else {
    this.props.respuestaPaso2(
      this.state.cantDiasSubsidios,
      this.state.diagnosticoMedico,
      this.state.nroHospital,
      this.state.hospitalDescripcion,
      this.state.nroMedico,
      this.state.medicoDescripcion,
      this.state.nroEnfermedad,
      undefined
      )}
    this.props.goToStep(5);
  };

  preventDefault = (e) => {
    e.preventDefault();
  };

  render() {
    let hospitales = this.loadHospitales();
    let medicos = this.loadMedicos();
    let enfermedades = this.loadEnfermedades();

    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuenta
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Reposo</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Agregar Datos de Reposo*/}
        <form id="idFormReposo" onSubmit={this.preventDefault}>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="form-group">
                    <label className="input-label-bold" htmlFor="cantidadDias">Días Subsidios *</label>
                    <input
                      type="number"
                      name="cantidadDias"
                      min={this.state.nroMinDiasSubsidio}
                      max={this.state.nroMaxDiasSubsidio}
                      placeholder="Ingrese Cantidad de Días"
                      className="input-box form-control"
                      style={{ textTransform: "lowercase" }}
                      onChange={this.handleChangeDias}
                    />
                    <span
                      style={{
                        display: "block",
                        fontSize: "small",
                        color: "#adadad",
                      }}
                    >
                      {"Cantidad entre "}{this.state.nroMinDiasSubsidio}{" y "}{this.state.nroMaxDiasSubsidio}{" días"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="form-group">
                    <label className="input-label-bold">
                      Breve diagnostico médico *
                    </label>
                    <textarea
                      type="text"
                      id="diagnostico-medico"
                      rows="4"
                      className="form-control"
                      onChange={this.handleChangeDiagnostico}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {
                      <SelectComponente
                        id="hospital"
                        titulo="Hospital"
                        presentacion="SELECT"
                        selectorValue={this.selectorValues.bind(this)}
                        itemSelected={this.state.nroHospital}
                        options={hospitales}
                      />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {
                    <SelectComponente
                      id="medico"
                      titulo="Médico"
                      presentacion="SELECT"
                      selectorValue={this.selectorValuesMed.bind(this)}
                      itemSelected={this.state.nroMedico}
                      options={medicos}
                    />
                    
                  }
                </div>
              </div>
            </div>
          </div>

          {
          this.props.respuestasData.claseSubsidio !== 210 && 
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {
                    <SelectComponente
                      id="enfermedad"
                      titulo="Enfermedad"
                      presentacion="SELECT"
                      selectorValue={this.selectorValuesEnf.bind(this)}
                      itemSelected={this.state.nroEnfermedad}
                      options={enfermedades}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          }
           <hr />
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-lg-6 col-md-6">
                  <label className="input-label-bold-obligatorio">
                    (*) Campos Obligatorios
                  </label>
                </div>
                <div className="col-lg-3 col-md-3 btn-consulta">
                <button
                className="btn btn-cu-quintary"
                onClick={this.volverSubsidios}
              >
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
                </div>
                <div className="col-lg-3 col-md-3">
                <button 
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary float-right"
                onClick={() => {
                  this.continuar();
                }}
              >
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}